import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkCard, UitkCardMedia, UitkCardContent, UitkCardTextSegment, UitkCardLink } from "uitk-react-cards";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { TopCitiesDefaultProps } from "../../typings";

const TopCitiesDefault = (props: TopCitiesDefaultProps) => {
  const { flexComponent, context } = props;
  const { id, model } = flexComponent;
  const { title, topCities } = model;
  const { formatText } = useLocalization();
  const cityCardKeyHelper = new ItemKeyHelper("topCitiesCard");

  const cityCards = topCities.map((city) => (
    <UitkCard key={cityCardKeyHelper.next()}>
      <UitkCardMedia>
        <UitkFigure ratio={UitkFigure.AspectRatio.R16_9}>
          <UitkImage src={city.imageUrl} alt={city.name} />
        </UitkFigure>
      </UitkCardMedia>

      <UitkCardContent>
        <UitkCardTextSegment>
          <UitkLayoutFlex justifyContent="space-between">
            <UitkText weight="bold">{city.name}</UitkText>
            {/* TODO: waiting for loc request to complete */}
            {Boolean(city.price) && (
              <UitkText>
                from <strong>{city.price}</strong>
              </UitkText>
            )}
          </UitkLayoutFlex>
        </UitkCardTextSegment>

        <UitkCardLink>
          <TrackedLink
            moduleName="topCities"
            rfrr="hotelTravelGuideLink"
            href={city.link}
            data-testid={`top-cities-default-${city.name}`}
          >
            {city.name}
          </TrackedLink>
        </UitkCardLink>
      </UitkCardContent>
    </UitkCard>
  ));

  return (
    <div id={id} className="TopCitiesDefault">
      <UitkHeading level={2} size={600}>
        {title || formatText("topCities.title", context.searchContext.location.localizedName)}
      </UitkHeading>

      <Viewport>
        <ViewSmall>
          <UitkLayoutGrid columns={1} space="three" className="all-t-margin-three">
            {cityCards}
          </UitkLayoutGrid>
        </ViewSmall>

        <ViewLarge>
          <UitkLayoutGrid columns={3} space="three" className="all-t-margin-three">
            {cityCards}
          </UitkLayoutGrid>
        </ViewLarge>
      </Viewport>
    </div>
  );
};

export default TopCitiesDefault;
